const _padZero = (val) => {
  if (val < 10) {
    return `0${val}`;
  }

  return val;
};

export const getDateString = () => {
  const currentDate = new Date();
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ];

  const month = months[currentDate.getMonth()];
  const date = currentDate.getDate();
  const year = currentDate.getFullYear();
  const hours = _padZero(currentDate.getHours());
  const minutes = _padZero(currentDate.getMinutes());
  const seconds = _padZero(currentDate.getSeconds());

  const tzOffset = currentDate.getTimezoneOffset() > 0
    ? `UTC-${currentDate.getTimezoneOffset() / 60}`
    : `UTC+${currentDate.getTimezoneOffset() / 60}`;

  // May25, 2020 23:23:34 (UTC+13)
  return `${month}${date}, ${year} ${hours}:${minutes}:${seconds} (${tzOffset})`;
};
